import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-high-potential',
  templateUrl: './high-potential.component.html',
  styleUrl: './high-potential.component.scss'
})
export class HighPotentialComponent {
  @Input() data;
  @Input() tooltip;
  @Input() queryParams;


  get highPotentialQueryParams(): any {
    return {
      ...(this.queryParams || {}),
      is_high_potential: 1
    };
  }
  
  get nonHighPotentialQueryParams(): any {
    return {
      ...(this.queryParams || {}),
      is_high_potential: 0
    };
  }
  
}
